import(new URL('bl-personalisation-font-picker.js', import.meta.url).href).catch((error) => {
  console.error('Font-name picker could not be initialised.', error);
});

const ASTYCA_FAMILY = 'Astyca Script';
const ASTYCA_OPTION_VALUE = 'Astyca Script';
const ASTYCA_ASSET = 'astyca-script.regular.ttf';
const CORE_ASSET = 'bl-personalisation-validation-core-20260719.js';

const assetUrl = (filename) => new URL(filename, import.meta.url).href;

const ensureAstycaFontLoaded = async () => {
  if (!('FontFace' in window) || !document.fonts) return;

  try {
    const face = new FontFace(ASTYCA_FAMILY, `url("${assetUrl(ASTYCA_ASSET)}")`, {
      style: 'normal',
      weight: '400',
      display: 'swap',
    });
    await face.load();
    document.fonts.add(face);
  } catch (error) {
    console.error('Unable to load Astyca Script font.', error);
  }
};

const isEngravingOrPlaque = (root) => {
  const method = (root.dataset.method || '').trim().toLowerCase();
  return method === 'engraving' || Boolean(root.querySelector('[data-bl-plaque]'));
};

const ensureAstycaOption = (root) => {
  if (!(root instanceof HTMLElement) || !isEngravingOrPlaque(root)) return;

  const select = root.querySelector('[data-bl-font]');
  if (!(select instanceof HTMLSelectElement)) return;

  const exists = [...select.options].some((option) => option.value === ASTYCA_OPTION_VALUE);
  if (exists) return;

  const option = document.createElement('option');
  option.value = ASTYCA_OPTION_VALUE;
  option.textContent = ASTYCA_OPTION_VALUE;
  select.append(option);
};

const applyAstycaPlaquePreview = (root) => {
  if (!(root instanceof HTMLElement) || !isEngravingOrPlaque(root)) return;

  const select = root.querySelector('[data-bl-font]');
  const preview = root.querySelector('[data-bl-preview-text]');
  if (!(select instanceof HTMLSelectElement) || !(preview instanceof HTMLElement)) return;

  if (select.value === ASTYCA_OPTION_VALUE) {
    preview.style.fontFamily = `"${ASTYCA_FAMILY}", cursive`;
  }
};

const prepareRoot = (root) => {
  ensureAstycaOption(root);
  applyAstycaPlaquePreview(root);
};

const prepareAll = (scope = document) => {
  if (scope instanceof Element && scope.matches('bl-personalisation')) {
    prepareRoot(scope);
  }

  scope.querySelectorAll?.('bl-personalisation').forEach(prepareRoot);
};

await ensureAstycaFontLoaded();
prepareAll();

const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    mutation.addedNodes.forEach((node) => {
      if (node instanceof Element) prepareAll(node);
    });
  }
});

observer.observe(document.documentElement, { childList: true, subtree: true });

await import(assetUrl(CORE_ASSET));

window.requestAnimationFrame(() => prepareAll());

document.addEventListener('input', (event) => {
  const root = event.target instanceof Element ? event.target.closest('bl-personalisation') : null;
  if (root) window.requestAnimationFrame(() => applyAstycaPlaquePreview(root));
});

document.addEventListener('change', (event) => {
  const root = event.target instanceof Element ? event.target.closest('bl-personalisation') : null;
  if (root) window.requestAnimationFrame(() => applyAstycaPlaquePreview(root));
});

document.addEventListener('shopify:section:load', (event) => {
  window.requestAnimationFrame(() => prepareAll(event.target));
});
